import axios from 'axios';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
    'version': '1.0.3',
  },
  withCredentials: true,
});

// Store for auth context reference (set by AuthProvider)
let authContextRef = null;

// Set auth context reference
export function setAuthContext(authContext) {
  authContextRef = authContext;
}

// Request interceptor - add Authorization header
apiClient.interceptors.request.use(
  async (config) => {
    if (authContextRef) {
      try {
        const token = await authContextRef.getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Failed to get access token for request:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle 401 errors - redirect to login
    if (error.response?.status === 401) {
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    }

    // Handle 403 version errors (existing behavior)
    if (error.response?.status === 403) {
      const resolveWithSomeData = new Promise(resolve => setTimeout(resolve, 3000));
      resolveWithSomeData.then(() => {
        if (window.customRegistration) {
          window.customRegistration.unregister().then(() => {
            window.location.reload();
          });
        } else {
          window.location.reload();
        }
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
